import { Constructor, DoorType } from "../@types/shared";
import {
    CGSDoubleSlidingDoorsCode,
    CGFDoubleSlidingDoorsCode,
    CGSDoubleSwingDoorsCode,
    CGFDoubleSwingDoorsCode,
    KompasDoubleFramedDoorCode,
    KompasSingleFramedDoorCode,
    CGSSingleSlidingDoorCode,
    CGFSingleSlidingDoorCode,
    CGSSingleSwingDoorCode,
    CGFSingleSwingDoorCode,
    SteelDoors,
} from "../constants";
import { DoorCutsCreationStrategies } from "../domain/strategies";
import { ICreateManyStrategy } from "../domain/strategies/base/creation.strategy";

export class DoorCutsStrategyRegistry {
    private strategies = new Map<string, Constructor<ICreateManyStrategy>>();

    // prettier-ignore
    constructor() {
        this.register(SteelDoors as DoorType[], DoorCutsCreationStrategies.SteelDoorCutsStrategy);
        this.register([CGSSingleSwingDoorCode,
            CGFSingleSwingDoorCode,] as DoorType[], DoorCutsCreationStrategies.SingleSwingDoorCutsStrategy);
        this.register([CGSSingleSlidingDoorCode,
            CGFSingleSlidingDoorCode,] as DoorType[], DoorCutsCreationStrategies.SingleSlidingDoorCutsStrategy);
        this.register([CGSDoubleSwingDoorsCode,
            CGFDoubleSwingDoorsCode,] as DoorType[], DoorCutsCreationStrategies.DoubleSwingDoorCutsStrategy);
        this.register([CGSDoubleSlidingDoorsCode,
            CGFDoubleSlidingDoorsCode,] as DoorType[], DoorCutsCreationStrategies.DoubleSlidingDoorCutsStrategy);
        this.register([KompasSingleFramedDoorCode] as DoorType[], DoorCutsCreationStrategies.KompasSingleDoorCutsStrategy);
        this.register([KompasDoubleFramedDoorCode] as DoorType[], DoorCutsCreationStrategies.KompasDoubleDoorCutsStrategy);
    }

    getStrategy = (
        doorCode: DoorType,
    ): Constructor<ICreateManyStrategy> | null => {
        return this.strategies.get(doorCode) || null;
    };

    private register = (
        doorTypes: DoorType[],
        strategy: Constructor<ICreateManyStrategy>,
    ) => {
        for (const doorType of doorTypes) {
            this.strategies.set(doorType, strategy);
        }
    };
}
